"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockUSDManager = exports.nullishFn = exports.promiseStrFn = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const promiseStrFn = () => Promise.resolve('');
exports.promiseStrFn = promiseStrFn;
const nullishFn = () => null;
exports.nullishFn = nullishFn;
class MockUSDManager {
    constructor() {
        this.getInformation = () => ({
            accessToken: '',
            refreshToken: '',
            agentToken: '',
            sessionId: (0, web_ui_framework_1.createUUID)(),
            interactionId: '',
            userName: '',
            documentType: '',
            platform: web_ui_framework_1.MBUSDPlatform.CC,
            agentTokenRequestPromise: null,
        });
        this.getMethods = () => ({
            // eslint-disable-next-line no-console
            registerTrace: console.log,
            raiseN2InIvr: exports.promiseStrFn,
            createPasswordOnboarding: exports.promiseStrFn,
            raiseN2OTPInIvr: exports.promiseStrFn,
            assistedAuthenticateSuccess: exports.nullishFn,
            getAgentAccessToken: exports.promiseStrFn,
            onLogoutSuccess: exports.nullishFn,
            onInvalidSession: exports.nullishFn,
            onExpiredSignatureKey: exports.nullishFn,
            refreshAgentToken: exports.nullishFn,
            verifyDataInIvr: exports.promiseStrFn,
        });
        this.initMethods = () => {
            throw new Error('initMethods not implemented');
        };
        this.parseInformation = (_data) => {
            throw new Error('parseInformation not implemented');
        };
        this.parseMethods = (_data) => {
            throw new Error('parseMethods not implemented');
        };
    }
}
exports.MockUSDManager = MockUSDManager;
//# sourceMappingURL=mockUsdManager.js.map